import axios from "axios";
import React, { createContext, useCallback, useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
import { baseUrl } from "../utils/baseUrl.js";
import { toast } from "react-toastify";

export const CartContext = createContext();

export default function CartContextProvider({ children }) {

    const token = "ecomm__" + localStorage.getItem("authorization")
    const [cartItems, setCartItems] = useState({})
    const notify = (msg, type) => toast[type](msg);


    async function addProductToCart(productId, quantity) {
        axios.post(
            `${baseUrl}/cart`,
            {
                productId,
                quantity
            },
            {
                headers: { authorization: token },
            }
        ).then((response) => {
            if (response.status === 200) {
                notify("Added to cart", "success")
                getUserCart()
            } else {
                notify("Failed", "error")
            }
        }).catch((error) => {
        })

    }

    async function removeProductFromCart(productId) {
        axios.patch(
            `${baseUrl}/cart`,
            {
                productId
            },
            {
                headers: { authorization: token },
            }
        ).then((response) => {
            if (response.data.message === "Deleted") {
                notify("Removed from cart", "success")
                getUserCart()
            } else {
                notify("Failed", "error")
            }
        }).catch((error) => {
        })
    }

    const getUserCart = useCallback(() => {
        axios.get(
            `${baseUrl}/cart`, {
            headers: { Authorization: token },
        }
        ).then((response) => {
            // if (response?.status === 200)
            setCartItems(response.data?.cart);
        }).catch((error) => {
            // if (error.response.status === 404)
            //     notify("Empty Cart", "error")
        })
    }, [token])


    useEffect(() => {
        if (localStorage.getItem("authorization")) {
            getUserCart()
        }
    }, [getUserCart, token])


    const cartIds = []


    cartItems?.products?.map(item => {
        return cartIds.push(item.productId._id)
    })


    function cartContains(ids, projId) {
        for (var i = 0; i < ids.length; i++) {
            if (ids[i] === projId) {
                return true;
            }
        }
        return false;
    }


    function increaseQuantity(quantity, stock, ID) {
        if (quantity > stock) {
            notify("Quantity must be less than or equal to stock", "error")
        } else {
            addProductToCart(ID, quantity + 1)
        }
    }
    function decreaseQuantity(quantity, ID) {
        if (quantity > 1) {
            addProductToCart(ID, quantity - 1)
        } else {
            notify("Quantity must be more than or equal to zero", "error")
        }
    }

    function getQuantity(e) {
        if (false) {
            notify("Quantity must be less than or equal to stock", "error")
        } else {
        }
    }



    return (
        <CartContext.Provider value={{ getUserCart, cartItems, cartContains, cartIds, increaseQuantity, decreaseQuantity, getQuantity, addProductToCart, removeProductFromCart }} >
            {children}
        </CartContext.Provider>
    )

}
